{
  "changes": {
    "added": "added",
    "modified": "changed",
    "removed": "removed",
    "unchanged": "unchanged"
  },
  "impact": {
    "absent": "No evidence from accepted saved runs on the changed documents. Check which runs are expected.",
    "acknowledge": "I have reviewed the changed and removed anchors and acknowledge their impact.",
    "acknowledgementNote": "Impact acknowledgement: what needs review next",
    "carried_one": "Carry-forward completed: {{count}} decision applied. Carried revisions are proposals for review.",
    "carried_other": "Carry-forward completed: {{count}} decisions applied. Carried revisions are proposals for review.",
    "carry": "Carry forward unchanged and moved anchors ({{count}})",
    "checkState": "Check server state",
    "decisions": {
      "carry_forward": "carried forward",
      "keep_historical": "kept historical",
      "re_review": "review again",
      "re_run": "run again",
      "withdraw": "withdrawn"
    },
    "documentsChanged_one": "{{count}} changed or removed document",
    "documentsChanged_other": "{{count}} changed or removed documents",
    "findings": "All dependent anchors ({{count}})",
    "mergeConfirmed": "The server confirms that this import is merged.",
    "merged": "Import merged.",
    "needsAttention": "Needs individual attention; this anchor is not eligible for bulk carry-forward.",
    "notResubmitted": "Sent once. The server may still be working; check status below.",
    "outcomes": {
      "changed": "changed",
      "moved": "moved",
      "removed": "removed",
      "unchanged": "unchanged"
    },
    "recorded_one": "{{count}} carry-forward decision recorded; {{remaining}}.",
    "recorded_other": "{{count}} carry-forward decisions recorded; {{remaining}}.",
    "remaining_one": "{{count}} eligible anchor remains",
    "remaining_other": "{{count}} eligible anchors remain",
    "stale": "The impact report belongs to another version of the proposal. Reload this review before merging.",
    "stillOpen": "The last check found the change set still open. The request may still be running.",
    "summary": "{{documents}}. Saved-run evidence anchors: {{changed}} changed, {{unchanged}} unchanged, {{moved}} moved, {{removed}} removed.",
    "title": "Impact on saved runs and other dependents",
    "working": "Working ({{seconds}} s elapsed). Keep this review open."
  },
  "list": {"title": "Corpus imports"},
  "page": {
    "addedText_one": "{{count}} character inserted",
    "addedText_other": "{{count}} characters inserted",
    "after": "After",
    "before": "Before",
    "columns": {
      "change": "Change",
      "characters": "Characters",
      "document": "Document",
      "pages": "Pages",
      "segments": "Segments"
    },
    "corpusMoved": "The corpus has a newer version than this import was planned on, so it cannot be merged. Scrap it and run the import again.",
    "counts": "{{added}} added | {{modified}} changed | {{removed}} removed | {{unchanged}} unchanged",
    "decision": "Your decision as curator of the corpus",
    "diffContext": "{{prefix}} unchanged characters before; {{suffix}} after",
    "documentText": "Whole document text",
    "documents_one": "{{count}} document",
    "documents_other": "{{count}} documents",
    "fileStays": "Source file on the PC the import runs on; checksum recorded with this import.",
    "importFile": "Import file",
    "inspectSegments": "Inspect segments",
    "into": "Import into {{corpus}}",
    "madeIn": "Made by the tool run in",
    "merge": "Merge: new corpus version",
    "next": "Next",
    "pagination": "Change list pages",
    "previous": "Previous",
    "provenance": "Where the documents come from",
    "range": "{{start}}-{{end}} of {{total}}",
    "reason": "Why",
    "removedText_one": "{{count}} character removed",
    "removedText_other": "{{count}} characters removed",
    "runtime": "Runtime",
    "scrap": "Scrap",
    "segmentationChanged": "The import also changes the corpus's segmentation.",
    "sourceFile": "Source file",
    "tool": "Tool"
  }
}
